import { css } from '@emotion/core';
import { tokens, media } from '@domain-group/fe-brary';
import { designTokenFonts } from '@domain-group/fe-co-allhomes-design-system';
var colors = tokens.colors;
export var footnote = /*#__PURE__*/css("color:", colors.neutral.heavy.default, ";margin-top:10px;", designTokenFonts.mini);
export var container = {
  name: "4pl3bs",
  styles: "max-width:640px;"
};
export var subheading = /*#__PURE__*/css(designTokenFonts.subheading, " margin:24px 0 12px;");
export var keyDetailItem = /*#__PURE__*/css("flex:0 0 100%;box-sizing:border-box;", media('>=tablet'), "{flex:0 0 50%;}");
export var contentsWithColumns = {
  name: "2imjyh",
  styles: "display:flex;flex-wrap:wrap;"
};
export var contents = {
  name: "j7qwjs",
  styles: "display:flex;flex-direction:column;"
};